import { render, staticRenderFns } from "./InputNumberGeneric.vue?vue&type=template&id=210485b9&scoped=true"
import script from "./InputNumberGeneric.vue?vue&type=script&lang=js"
export * from "./InputNumberGeneric.vue?vue&type=script&lang=js"
import style0 from "./InputNumberGeneric.vue?vue&type=style&index=0&id=210485b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210485b9",
  null
  
)

export default component.exports